import { render, staticRenderFns } from "./CruiseSlideCard.vue?vue&type=template&id=ded5b0aa&scoped=true&"
import script from "./CruiseSlideCard.vue?vue&type=script&lang=js&"
export * from "./CruiseSlideCard.vue?vue&type=script&lang=js&"
import style0 from "./CruiseSlideCard.vue?vue&type=style&index=0&id=ded5b0aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded5b0aa",
  null
  
)

export default component.exports